import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { BarChartDatePeriod } from 'tms-lib';

@Component({
  selector: 'app-stock-enquiry-dashboard',
  templateUrl: './stock-enquiry-dashboard.component.html',
  styleUrl: './stock-enquiry-dashboard.component.scss',
})
export class StockEnquiryDashboardComponent implements OnInit {
  @Input() productId: string;
  barChartPeriod = BarChartDatePeriod.Year;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    if (!this.productId) {
      this.productId = this.route.snapshot.paramMap.get('id');
    }
  }
}
